import TransferList, {
  TransferDataType,
} from "@/components/atoms/TransferList";
import { useEffect, useState } from "react";
import Button from "@/components/atoms/Button";
import OrderedData from "@/types/OrderedData";
import { router } from "@inertiajs/react";
import useAccess from "@/hooks/useAccess";

type Props = {
  accountId: number;
  data: TransferDataType[];
  sourceData: TransferDataType[];
  apiURL: string;
  idKey: string;
  accessKeys: string[];
};

const TransferTab = ({
  apiURL,
  idKey,
  accountId,
  data,
  sourceData,
  accessKeys,
}: Props) => {
  
  const { getAccess } = useAccess();
  const [loading, setLoading] = useState(false);
  const [targets, setTargets] = useState<TransferDataType[]>(data);

  const hasAccess = getAccess(accessKeys);

  /*useEffect(() => {
    setTargets(data.sort((a, b) => a.order - b.order));
  }, [data]);*/

  const handleSave = () => {
    router.post(
      `/accounts/${accountId}/${apiURL}`,
      {
        data: targets.flatMap((target, ind) => {
          // Parent elemanını ekle
          const result = [
            {
              [idKey]: target.id,
              order: ind + 1,
            },
          ];
    
          // Eğer children varsa onları da ekle
          if (target.children && target.children.length > 0) {
            result.push(
              ...target.children.map((child, childInd) => ({
                [idKey]: child.id,
                order: ind + 1 + (childInd + 1) / 10, // Child'lara sıralama için fractional eklenebilir
              }))
            );
          }
    
          return result;
        }),
      },
      {
        onStart: () => setLoading(true),
        onFinish: () => setLoading(false),
      }
    );
  };

  return (
    <div className="p-6">
      <TransferList
        titles={["Available", "Selected"]}
        sourceData={sourceData}
        constSourceData={sourceData}
        targetData={targets}
        access={hasAccess}
        onSelectedChange={(targets) => {
          const uniqueTargets = targets.reduce((acc: TransferDataType[], target) => {
            if (!acc.some(item => item.id === target.id)) {
              acc.push(target);
            }
            return acc;
          }, []);
          
          if (hasAccess) setTargets(uniqueTargets);
        }}
      />
      <Button
        className="float-right"
        onClick={handleSave}
        disabled={loading || !hasAccess}
      >
        Save
      </Button>
    </div>
  );
};

export default TransferTab;
